import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'conversations-http/clients/http';
import { CLOSE_TICKET_SLA, FIRST_RESPONSE_SLA, IN_SLA_PROPERTY_VALUE, NEXT_RESPONSE_SLA } from 'conversations-internal-schema/sla/constants/enums';
export const PAUSED_TIME_LEFT_QUERY = registerQuery({
  args: ['ticketId'],
  fetcher: ({
    ticketId
  }) => {
    return http.get(`cv-goals/v1/goals/details/tickets/${ticketId}/time-left`);
  },
  fieldName: 'pausedTimeLeftQuery'
});
export const usePausedTimeLeft = ({
  slas,
  ticketId
}) => {
  const {
    data,
    error,
    loading
  } = useQuery(PAUSED_TIME_LEFT_QUERY, {
    fetchPolicy: 'network-only',
    variables: {
      ticketId
    }
  });
  return {
    data,
    error,
    loading,
    allSLAData: convertPausedDataToSLACategories({
      pausedTimeLeft: data === null || data === void 0 ? void 0 : data.pausedTimeLeftQuery,
      slas
    })
  };
};

// IN_SLA_PROPERTY_VALUE is used here because the paused status is not a real status,
// and we need something for `status`
const noOpStatus = IN_SLA_PROPERTY_VALUE;
// The API returns the amount of time left in milliseconds, so we need to convert
// each date into future looking times
export function convertPausedDataToSLACategories({
  // This is passed in as an argument so it can be mocked in tests
  currentTime = Date.now(),
  pausedTimeLeft,
  slas
}) {
  var _slas$FIRST_RESPONSE_, _slas$FIRST_RESPONSE_2, _slas$NEXT_RESPONSE_S, _slas$NEXT_RESPONSE_S2, _slas$CLOSE_TICKET_SL, _slas$CLOSE_TICKET_SL2, _slas$FIRST_RESPONSE_3, _slas$FIRST_RESPONSE_4, _slas$NEXT_RESPONSE_S3, _slas$NEXT_RESPONSE_S4, _slas$CLOSE_TICKET_SL3, _slas$CLOSE_TICKET_SL4;
  if (!pausedTimeLeft) {
    return null;
  }
  const firstResponseDueDate = pausedTimeLeft.timeToFirstResponse ? currentTime + pausedTimeLeft.timeToFirstResponse : (_slas$FIRST_RESPONSE_ = (_slas$FIRST_RESPONSE_2 = slas[FIRST_RESPONSE_SLA]) === null || _slas$FIRST_RESPONSE_2 === void 0 ? void 0 : _slas$FIRST_RESPONSE_2.dueDate) !== null && _slas$FIRST_RESPONSE_ !== void 0 ? _slas$FIRST_RESPONSE_ : 0;
  const firstResponseIsPaused = !!pausedTimeLeft.timeToFirstResponse;
  const nextResponseDueDate = pausedTimeLeft.timeToNextResponse ? currentTime + pausedTimeLeft.timeToNextResponse : (_slas$NEXT_RESPONSE_S = (_slas$NEXT_RESPONSE_S2 = slas[NEXT_RESPONSE_SLA]) === null || _slas$NEXT_RESPONSE_S2 === void 0 ? void 0 : _slas$NEXT_RESPONSE_S2.dueDate) !== null && _slas$NEXT_RESPONSE_S !== void 0 ? _slas$NEXT_RESPONSE_S : 0;
  const nextResponseIsPaused = !!pausedTimeLeft.timeToNextResponse;
  const closeTicketDueDate = pausedTimeLeft.timeToClose ? currentTime + pausedTimeLeft.timeToClose : (_slas$CLOSE_TICKET_SL = (_slas$CLOSE_TICKET_SL2 = slas[CLOSE_TICKET_SLA]) === null || _slas$CLOSE_TICKET_SL2 === void 0 ? void 0 : _slas$CLOSE_TICKET_SL2.dueDate) !== null && _slas$CLOSE_TICKET_SL !== void 0 ? _slas$CLOSE_TICKET_SL : 0;
  const closeTicketIsPaused = !!pausedTimeLeft.timeToClose;
  return {
    [FIRST_RESPONSE_SLA]: {
      category: FIRST_RESPONSE_SLA,
      status: firstResponseIsPaused ? noOpStatus : (_slas$FIRST_RESPONSE_3 = (_slas$FIRST_RESPONSE_4 = slas[FIRST_RESPONSE_SLA]) === null || _slas$FIRST_RESPONSE_4 === void 0 ? void 0 : _slas$FIRST_RESPONSE_4.status) !== null && _slas$FIRST_RESPONSE_3 !== void 0 ? _slas$FIRST_RESPONSE_3 : noOpStatus,
      dueDate: firstResponseDueDate,
      priority: 0,
      isPaused: firstResponseIsPaused
    },
    [NEXT_RESPONSE_SLA]: {
      category: NEXT_RESPONSE_SLA,
      status: nextResponseIsPaused ? noOpStatus : (_slas$NEXT_RESPONSE_S3 = (_slas$NEXT_RESPONSE_S4 = slas[NEXT_RESPONSE_SLA]) === null || _slas$NEXT_RESPONSE_S4 === void 0 ? void 0 : _slas$NEXT_RESPONSE_S4.status) !== null && _slas$NEXT_RESPONSE_S3 !== void 0 ? _slas$NEXT_RESPONSE_S3 : noOpStatus,
      dueDate: nextResponseDueDate,
      priority: 0,
      isPaused: nextResponseIsPaused
    },
    [CLOSE_TICKET_SLA]: {
      category: CLOSE_TICKET_SLA,
      status: closeTicketIsPaused ? noOpStatus : (_slas$CLOSE_TICKET_SL3 = (_slas$CLOSE_TICKET_SL4 = slas[CLOSE_TICKET_SLA]) === null || _slas$CLOSE_TICKET_SL4 === void 0 ? void 0 : _slas$CLOSE_TICKET_SL4.status) !== null && _slas$CLOSE_TICKET_SL3 !== void 0 ? _slas$CLOSE_TICKET_SL3 : noOpStatus,
      dueDate: closeTicketDueDate,
      priority: 0,
      isPaused: closeTicketIsPaused
    }
  };
}